import { Command } from '@ckeditor/ckeditor5-core';
import { first } from '@ckeditor/ckeditor5-utils';
export default class InsertCalloutCommand extends Command {
    refresh() {
        this.value = this._getValue();
        this.isEnabled = this._checkEnabled();
    }
    execute(options) {
        const model = this.editor.model;
        const schema = model.schema;
        const selection = model.document.selection;
        const blocks = Array.from(selection.getSelectedBlocks());
        const value = !options || options.forceValue === undefined ? !this.value : options.forceValue;
        model.change((writer) => {
            if (!value) {
                this._removeCallout(writer, blocks.filter(findCallout));
            }
            else {
                const blocksToCallout = blocks.filter((block) => {
                    return findCallout(block) || checkCanBeCallouted(schema, block);
                });
                this._applyCallout(writer, blocksToCallout);
            }
        });
    }
    _getValue() {
        const selection = this.editor.model.document.selection;
        const firstBlock = first(selection.getSelectedBlocks());
        return !!(firstBlock && findCallout(firstBlock));
    }
    _checkEnabled() {
        if (this.value) {
            return true;
        }
        const selection = this.editor.model.document.selection;
        const schema = this.editor.model.schema;
        const firstBlock = first(selection.getSelectedBlocks());
        if (!firstBlock) {
            return false;
        }
        return checkCanBeCallouted(schema, firstBlock);
    }
    _removeCallout(writer, blocks) {
        getRangesOfBlockGroups(writer, blocks)
            .reverse()
            .forEach((groupRange) => {
            if (groupRange.start.isAtStart && groupRange.end.isAtEnd) {
                writer.unwrap(groupRange.start.parent);
                return;
            }
            if (groupRange.start.isAtStart) {
                const positionBefore = writer.createPositionBefore(groupRange.start.parent);
                writer.move(groupRange, positionBefore);
                return;
            }
            if (!groupRange.end.isAtEnd) {
                writer.split(groupRange.end);
            }
            const positionAfter = writer.createPositionAfter(groupRange.end.parent);
            writer.move(groupRange, positionAfter);
        });
    }
    _applyCallout(writer, blocks) {
        const calloutsToMerge = [];
        getRangesOfBlockGroups(writer, blocks)
            .reverse()
            .forEach((groupRange) => {
            let callout = findCallout(groupRange.start);
            if (!callout) {
                callout = writer.createElement('callout');
                writer.wrap(groupRange, callout);
            }
            calloutsToMerge.push(callout);
        });
    }
}
function findCallout(elementOrPosition) {
    var _a;
    return ((_a = elementOrPosition === null || elementOrPosition === void 0 ? void 0 : elementOrPosition.parent) === null || _a === void 0 ? void 0 : _a.name) == 'callout' ? elementOrPosition.parent : null;
}
function getRangesOfBlockGroups(writer, blocks) {
    let startPosition = null;
    let i = 0;
    const ranges = [];
    while (i < blocks.length) {
        const block = blocks[i];
        const nextBlock = blocks[i + 1];
        if (!startPosition) {
            startPosition = writer.createPositionBefore(block);
        }
        if (!nextBlock || block.nextSibling != nextBlock) {
            ranges.push(writer.createRange(startPosition, writer.createPositionAfter(block)));
            startPosition = null;
        }
        i++;
    }
    return ranges;
}
function checkCanBeCallouted(schema, block) {
    const isCalloutAllowed = schema.checkChild(block.parent, 'callout');
    const isBlockAllowedInCallout = schema.checkChild(['$root', 'callout'], block);
    return isCalloutAllowed && isBlockAllowedInCallout;
}
